<template>
  <div>
    <div class="head-box">
      <h4 class="c-flex c-flex-item">
        企微任务管理
      </h4>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="搜索任务名称"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click.native="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-dropdown class="c-m-l-10">
          <el-button type="primary">
            新增任务
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="doNew(1)">创建客户群</el-dropdown-item>
            <el-dropdown-item @click.native="doNew(2)">拉成员进客户群</el-dropdown-item>
            <el-dropdown-item @click.native="doNew(3, 'text')">发送文本消息</el-dropdown-item>
            <el-dropdown-item @click.native="doNew(3, 'image')">发送图片消息</el-dropdown-item>
            <el-dropdown-item @click.native="doNew(3, 'video')">发送视频消息</el-dropdown-item>
            <el-dropdown-item @click.native="doNew(3, 'file')">发送文件消息</el-dropdown-item>
            <el-dropdown-item @click.native="doNew(3, 'news')">发送H5消息</el-dropdown-item>
            <el-dropdown-item @click.native="doNew(3, 'miniprogram')">
              发送小程序消息
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport(
              {
                'in:state|array-integer#and': '0,1',
                'regex:name|string#or': searchValue,
                sortField: 'createTime',
                sortOrder: 'desc',
                beanName: 'eWechatTask',
                title: '企微任务'
              },
              { dynamic: true }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table ref="table" :data="fpi.data" empty-text="暂无数据" height="calc(100% - 50px)">
          <c-table :fields="extFields"></c-table>
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="doRemove(scope.row._id)">
                    删除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="企微任务管理" :visible.sync="openDetail">
      <c-form
        :formData="formData"
        :fields="extFields"
        :area="area"
        :upload="upload"
        :options="options"
        ref="form"
        labelWidth="150px"
        @changeForm="osg.changeForm"
      ></c-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'eWechatTask',
  data() {
    window.$this = this;
    return {
      name: 'eWechatTask',
      fpi: { data: [] },
      searchValue: '',
      openDetail: false,
      extFields: [],
      formData: {
        userIds: [],
        contactIds: [],
        saNoChatId: [],
        saChatId: [],
        imgUrl: [],
        exts: {}
      },
      rules: this.$util.rules,
      options: {},
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      timer: null
    };
  },
  mounted() {
    this.osg.getFields('eWechatTask', () => {
      this.osg.getFpi();
      this.getData();
      // 每隔5秒查询一次列表，更新任务执行状态。
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.getData();
      }, 5000);
    });
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    getData() {
      let params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        'in:state|array-integer#and': '0,1',
        'regex:name|string#or': this.searchValue,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax(
        '/biz/qwtask/query.do',
        params,
        res => {
          res.data.map(item => {
            item.exts = item.exts || {};
          });
          this.fpi = res;
          this.$nextTick(() => {
            this.$refs.table.doLayout();
            this.$forceUpdate();
          });
        },
        {
          noload: true
        }
      );
    },
    doNew(type, msgtype) {
      this.doInit();
      this.$set(this.formData, 'type', type);
      this.$set(this.formData, 'msgtype', msgtype);
      if (msgtype == 'image' || msgtype == 'video' || 'msgtype' == 'file') {
        this.$set(this.formData, 'content', []);
      } else {
        this.$set(this.formData, 'content', '');
      }
      this.openDetail = true;
    },
    doInit() {
      this.openDetail = false;
      this.formData = {
        userIds: [],
        contactIds: [],
        saNoChatId: [],
        saChatId: [],
        imgUrl: [],
        exts: {}
      };
    },
    doSave() {
      if (this.formData.type == 1) {
        this.openChat();
      } else if (this.formData.type == 2) {
        this.updateChat();
      } else if (this.formData.type == 3) {
        if (
          this.formData.msgtype == 'text' ||
          this.formData.msgtype == 'image' ||
          this.formData.msgtype == 'video' ||
          this.formData.msgtype == 'file'
        ) {
          this.sendBaseMsg();
        } else if (this.formData.msgtype == 'news') {
          this.sendNews();
        } else if (this.formData.msgtype == 'miniprogram') {
          this.sendMini();
        }
      }
    },
    doRemove(id) {
      this.osg.confirm('是否确认删除？', () => {
        this.osg.ajax('/biz/qwtask/remove.do', { id }, () => {
          this.osg.toast('删除成功');
          this.getData();
        });
      });
    },
    // 创建客户群
    openChat() {
      if (this.osg.validate()) {
        let test = this.formData;
        debugger;
        this.osg.ajax(
          '/biz/qwtask/openChat.do',
          {
            userIds: this.formData.userIds.join(),
            contactIds: this.formData.contactIds.join(),
            bizType: this.formData.bizType,
            bizId: this.formData.bizId
          },
          () => {
            this.osg.toast('保存成功');
            this.doInit();
            this.getData();
          }
        );
      }
    },
    // 拉成员进客户群
    updateChat() {
      if (this.osg.validate()) {
        this.osg.ajax(
          '/biz/qwtask/updateChat.do',
          {
            userIds: this.formData.userIds.join(),
            bizType: this.formData.bizType,
            bizId: this.formData.bizId
          },
          () => {
            this.osg.toast('保存成功');
            this.doInit();
            this.getData();
          }
        );
      }
    },
    // 发送文本/图片/视频/文件消息
    async sendBaseMsg() {
      if (this.osg.validate()) {
        if (
          (this.formData.msgtype == 'image' ||
            this.formData.msgtype == 'video' ||
            this.formData.msgtype == 'file') &&
          Array.isArray(this.formData.content)
        ) {
          await this.uploadMedia();
        }
        this.osg.ajax(
          '/biz/qwtask/sendBaseMsg.do',
          {
            msgtype: this.formData.msgtype,
            content: this.formData.content,
            bizType: this.formData.bizType,
            bizId: this.formData.bizId,
            mediaUrl: this.formData.midiaUrl
          },
          () => {
            this.osg.toast('保存成功');
            this.doInit();
            this.getData();
          }
        );
      }
    },
    // 上传媒体文件到企微服务器
    uploadMedia() {
      return new Promise(resolve => {
        if (
          !this.formData.content[0] ||
          !this.formData.content[0].response ||
          !this.formData.content[0].response.key
        ) {
          this.osg.toast('请等待文件上传完成再提交！', 'warning');
        } else {
          this.osg.ajax(
            '/biz/qwtask/uploadMedia.do',
            {
              corpId: 'wwb580bbf2548e6123',
              type: this.formData.msgtype,
              resourceUrl: this.osg.downloadUrl + this.formData.content[0].response.key
            },
            res => {
              this.formData.midiaUrl = this.osg.downloadUrl + this.formData.content[0].response.key;
              this.formData.content = res.data.media_id;
              resolve();
            }
          );
        }
      });
    },
    // 发送H5消息
    sendNews() {
      this.osg.ajax(
        '/biz/qwtask/sendNews.do',
        {
          link: this.formData.link,
          title: this.formData.title,
          imgUrl: this.osg.downloadUrl + this.formData.imgUrl[0].response.key,
          desc: this.formData.desc,
          bizType: this.formData.bizType,
          bizId: this.formData.bizId
        },
        res => {
          this.osg.toast('保存成功');
          this.doInit();
          this.getData();
        }
      );
    },
    // 发送H5消息
    sendMini() {
      this.osg.ajax(
        '/biz/qwtask/sendMini.do',
        {
          link: this.formData.link,
          title: this.formData.title,
          imgUrl: this.osg.downloadUrl + this.formData.imgUrl[0].response.key,
          appId: this.formData.appId,
          bizType: this.formData.bizType,
          bizId: this.formData.bizId
        },
        res => {
          this.osg.toast('保存成功');
          this.doInit();
          this.getData();
        }
      );
    }
  }
};
</script>
<style lang="scss"></style>
